import { useEffect, useMemo, useState } from 'react'
import { getAllWarehouses } from '../services/warehouses.service'

export const usePickupWarehouses = (enabledWarehouseIds) => {
  const enabledIds = useMemo(() => {
    const list = Array.isArray(enabledWarehouseIds) ? enabledWarehouseIds : []
    return list.filter((x) => typeof x === 'string' && x.trim()).map((x) => x.trim())
  }, [enabledWarehouseIds])

  const [warehouses, setWarehouses] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false
    const run = async () => {
      setLoading(true)
      setError(null)
      try {
        if (!enabledIds.length) {
          if (!cancelled) setWarehouses([])
          return
        }
        const rows = await getAllWarehouses()
        const filtered = (Array.isArray(rows) ? rows : []).filter((w) => enabledIds.includes(w.id))
        if (!cancelled) setWarehouses(filtered)
      } catch (e) {
        if (!cancelled) setError(e?.message || 'Error desconocido')
      } finally {
        if (!cancelled) setLoading(false)
      }
    }
    run()
    return () => {
      cancelled = true
    }
  }, [enabledIds])

  return { warehouses, loading, error }
}

export default usePickupWarehouses
